<template>
    <div>
        <H1Heading>Accessibility</H1Heading>
        Coming soon...
    </div>
</template>

<script>
export default {
    name: "Index",
};
</script>

<style scoped></style>
